export const MANDATE_30_DAYS = 'MANDAT 30 JOURS';
export const PAID_NEXTORE_PRODUCT_IDENTIFIER = 'Deduction montant paye';